module.exports = __webpack_public_path__ + "static/media/check-delivry-rates.8f8f4954.png";